import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useRouter } from "next/router";
import { actions } from "@/reducers/get-my-products-reducer";

export default function useMyProducts() {
  const dispatch = useDispatch();
  const { isReady, query } = useRouter();
  const { context, userPq, customer, userCompatibilities } = useSelector(state => state.main);
  const offerCategory = JSON.stringify(query.offerCategory ?? null);
  const profileIds = JSON.stringify(query.userProfileId ?? null);

  useEffect(() => {
    if (isReady && userPq != null) dispatch(actions.getMyProducts());
  }, [dispatch, isReady, context?.userType, userPq, customer, userCompatibilities, offerCategory, profileIds]);
}
